import { getValueFilters } from "PFApp/use_filtered_collection/format_filters";
import { Meta } from "PFTypes";
import { useEffect } from "react";

import { useMarketplaceContext } from "../../contexts/marketplace_context";
import { useWorkOpportunitiesTab } from "./use_work_opportunities_tab";

export const useMetaUpdates = (meta: Meta) => {
  const { handleFiltersReplace, setOrder } = useMarketplaceContext();
  const currentTab = useWorkOpportunitiesTab();

  useEffect(() => {
    if (meta.filters) {
      handleFiltersReplace(getValueFilters(meta.filters), currentTab!);
    }
  }, [meta.filters, handleFiltersReplace, currentTab]);

  useEffect(() => {
    if (meta.order) {
      setOrder(meta.order.value, currentTab!);
    }
  }, [currentTab, meta.order, setOrder]);
};
